<template>
  <div class="item_block">
    <div class="item_header_block">
      <div class="item_header_container">
        <div class="item_header_label">
          <div class="item_header_text">
            {{ data.translations.find(({locale}) => locale === currentLocale).title }}
          </div>
          <div class="item_header_date">
            {{ $t('Date') }}: {{data.published_date | formatDate('DD.MM.YY')}}
          </div>
        </div>
        <div class="item_header_slider">
          <div class="item_header_slider_container">
            <img :src="data.image ? getImagePath(data.image.path) : ''" alt="Изображение новости" class="item_header_img">
            <div v-if="data.image && data.image.description" class="item_header_img_text">{{data.image.description}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="item_article_block">
      <div class="item_article_container">
        <div class="item_article_label">
          <div class="item_article" v-html="data.translations.find(({locale}) => locale === currentLocale).text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NewsItem",
    data() {
      return {
        data: {},
        currentLocale : this.$i18n.locale,
      };
    },
    methods: {
      getImagePath(path) {
        return API_ROOT + path;
      }
    },
    mounted() {
      this.$http.get(`${API_ROOT}/api/news/${this.$route.params.id}`)
        .then(({data}) => {
          this.data = data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
</script>

<style scoped>

</style>
